















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import { authenticationService } from "@/_services";
import Dropdown from "vue-simple-search-dropdown";


@Component({
  components: { Dropdown },
})
export default class DocumentProcesses extends Vue {
  items: any[] = [];
  currentPage = 1;
  defaultSortDir = "desc";
  user: any = {};
  users: any[] = [];
  query = {};
  from = null;
  until = null;
  searchName = "";

  monthNames = [
    "Siječanj",
    "Veljača",
    "Ožujak",
    "Travanj",
    "Svibanj",
    "Lipanj",
    "Srpanj",
    "Kolovoz",
    "Rujan",
    "Listopad",
    "Studeni",
    "Prosinac",
  ];

  dayNames = ["N", "P", "U", "S", "Č", "P", "S"];

  format = "DD.MM.YYYY, HH:mm";



   get filteredItems() {
    if (this.searchName || this.from !== null || this.until != null) {
      var filter = this.searchName.toLowerCase();
      return this.items.filter(this.filterByAll);
    }
    return this.items;
  }

   filterByAll(item) {

const publishingDate = moment(item.planned_publishing_date);

    if (this.from){
        var  fromMoment = moment(this.from);
        if (publishingDate.isBefore(fromMoment)) return false;
    }
      
    if (this.until){
         var untilMoment = moment(this.until);
        if (publishingDate.isAfter(untilMoment)) return false;
    }
     

    if (item.document_name.toLowerCase().indexOf(this.searchName.toLowerCase()) !== -1){
      return true;
    }

    if(item.assigned_to_name){
      if(item.assigned_to_name.toLowerCase().indexOf(this.searchName.toLowerCase()) !== -1){
          return true;
      }
    }

    if(item.temporal_coverage){
      if(item.temporal_coverage.toLowerCase().indexOf(this.searchName.toLowerCase()) !== -1){
        return true; 
      }
    }

    return false;
}

 resetSearch() {
    this.from = null;
    this.until = null;
    this.searchName = "";
  }



  async startProcess(documentId: number, processId: number) {
    const result = await axios.post(
      "/process/start",
      {
        documentId,
        processId,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      }
    );

    this.load();
  }

  async finishProcess(documentId: number, processId: number) {
    await axios.post<any>(
      "/process/finish",
      {
        documentId,
        processId,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      }
    );

    this.load();
  }

  async assignNote(node: any){
    await axios.post<any>(
      "/process/assignnote",
      {
        documentId: node.document_id,
        processId: node.process_id,
        process_note: node.process_note_input
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      }
    );

    //this.load();
    node.process_note = node.process_note_input;

  }

  async assign(node: any, userId: number) {
    await axios.post<any>(
      "/process/assign",
      {
        documentId: node.document_id,
        processId: node.process_id,
        assignedToId: userId,
        assignedBy: localStorage.userName,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      }
    );

    this.load();
  }

  async load() {
    const raw = (
      await axios.get<any[]>("/process", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;

    const rows = raw.map((el) => {
      el.start_date = moment(el.start_date); //  new Date(el.start_date);
      el.due_date = moment(el.due_date);
      el.modified_date = moment(el.modified_date);
      el.planned_publishing_date = moment(el.planned_publishing_date);
      // el.progress = this.getProgress(el);
      return el;
    });

    const items: any[] = [];

    // group docs in 'archive' property with same document_id
    let currentDoc: any = null;
    rows.map((el) => {
      if (currentDoc != el.document_id) {
        el.archive = [];
        items.push(el);
        currentDoc = el.document_id;
      } else {
        items[items.length - 1].archive.push(el);
      }
    });

    this.items = items;
  }

  isAdmin() {
    return this.user.role == "Admin";
  }

  isManager() {
    return this.user.role == "Manager";
  }

  isWorker() {
    return this.user.role == "Worker";
  }

  async mounted() {
    // var res = await axios.get("/auth/status");
    //this.user = JSON.parse(localStorage.user);
    this.users = (
      await axios.get<any[]>("/process/users", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.user = authenticationService.currentUserValue;
    this.load();
  }



 

}
